import { useEffect } from "react";
import useSiteMotion from "./useSiteMotion";

/**
 * Reveals elements with `.reveal` class as they enter the viewport AND
 * powers the entire site's motion language — kinetic headlines, magnetic
 * CTAs, count-up numbers — via the `useSiteMotion` hook.
 *
 * Pages already call `useScrollReveal()` so motion comes online site-wide
 * without per-page wiring.
 */
export default function useScrollReveal(selector = ".reveal") {
  useSiteMotion();
  useEffect(() => {
    const els = document.querySelectorAll(selector);
    if (!els.length) return;

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: "0px 0px -60px 0px" },
    );

    els.forEach((el) => io.observe(el));
    return () => io.disconnect();
  });
}
